import type { z } from 'zod';

// A URL filter value the API would reject (an unknown facet, an oversize
// search) reads as absent rather than failing the whole filter parse, which
// would turn the list into an error or drop every other filter with it.
export function lenient<T extends z.ZodTypeAny>(schema: T) {
  return schema.optional().catch(undefined);
}
